import { Injectable } from "@angular/core";
import { ListMetadata } from "app/models/list-metadata.model";
import { HttpClientService } from "app/services/httpClient/httpclient.service";
import { Observable } from "rxjs";
import { ChallengeDetail, ChallengeDetailElaborated, ChallengePeriodOverviewChartesian, ChallengeResponse, GraphicsDTO, GraphicsDTOChartesian, OverviewPartecipantsDTO, ParticipantOverview, ParticipantOverviewResponse, ParticipantsOverviewSummary, SaveChallengeDto } from "./challenge.model";
import { PremioDTO } from "./gifts/gifts-edit-create.component";
import { AcmTypehasReason } from "app/models/loyalty-acm-type.model";
import { HttpParams } from "@angular/common/http";
import { ChallengeDetailTotalResponse, ChallengeEditResponse } from "./challenge-creation/challenge-creation.component";
import { ReachedLevel } from "../customerDB/customers/challenge/challenge-3-kontable/challenge-3-kontable.component";
import { forkJoin } from "rxjs/observable/forkJoin";
import { ChallengeTemplate } from "app/models/challenge-template";
import { Touchpoint } from "../campaign-3/models/campaign-3.model";
import { FrequencyParam } from "../baskets/baskets.model";

@Injectable()
export class ChallengeService {





  constructor(private http: HttpClientService) { }

  private readonly baseUrl = '/k7o/gui-shim/loy/challenge/challenge/gui';
  singleChallenge: ChallengeResponse


  list(
    offset: number | null = null,
    limit: number | null = null,
    search?: Array<{ key: string; value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<ChallengeResponse>; metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    const paramsString = params.toString().replace(/\+/g, '%2B');

    return this.http.getPaged(`${this.baseUrl}/listPage?${paramsString}`);
  }
  private challengeDetailsUrl = '/k7o/gui-shim/loy/challenge';
  getCampaignChallengeDetails(challengeId: number): Observable<ChallengeDetail[]> {
    return this.http.get(this.challengeDetailsUrl + "/challenge-detail/gui/level/list/" + challengeId.toString());
  }

  getCampaignChallengeDetailsForEdit(challengeId: number, id: number): Observable<ChallengeDetail> {
    return this.http.get(this.challengeDetailsUrl + "/challenge-detail/details/list?challenge_id=" + challengeId.toString() + "&id=" + id);
  }

  challengeTypeUrl = '/k7o/gui-shim/loy/challenge/challenge-type/list';

  getChallengeTypeList(): Observable<any> {
    return this.http.get(
      this.challengeTypeUrl
    );
  }

  /*   private touchPointUrl = '/koncentro-promo/touch-point';
   getTouchPoints(): Observable<any[]> {
     return this.http.get(this.touchPointUrl);
   }  */
  private touchPointUrl = '/koncentro-promo/touch-point/challenge';
  getTouchPoints(): Observable<any[]> {
    return this.http.get(this.touchPointUrl);
  }


  distrUrl = 'koncentro-promo/campaign';
  getDistributionListDetailsForChallenge(id: string) {

    return this.http.getPaged(this.distrUrl + '/distribution_list/details?distribution_list_id=' + id);
  }

  getChallengeById(currentChallengeId: number): Observable<{ data: ChallengeResponse[] }> {
    return this.http.getPaged(`${this.baseUrl}/list?id=${currentChallengeId}`);
  }



  //----------------CRUD LIVELLI---------------------------


  challengeDetailUrl = 'k7o/gui-shim/loy/challenge/challenge-detail';
  challengeDetailAcmUrl = 'k7o/gui-shim/loy/challenge/challenge-detail-acm/saveChallengeDetailAcmList';
  challengeDetailEditAcmUrl = 'k7o/gui-shim/loy/challenge/challenge-detail-acm/editChallengeDetailAcmList';

  /*   //EDIT della testata
    updateChallengeDetail(idLevel: number, payload: any): Observable<any> {
      return this.http.put(
        `${this.challengeDetailUrl}/${idLevel}`,
        payload
      );
    }
    //EDIT degli accumulatori di livello
    updateChallengeDetailAcm(payload: any[]): Observable<any> {
      return this.http.put(
        `${this.challengeDetailEditAcmUrl}`,
        payload
      );
    }

    // POST per creare un nuovo challenge detail
    createChallengeDetail(payload: any): Observable<any> {
      return this.http.post(
        `${this.challengeDetailUrl}`,
        payload
      );
    }

    // POST per creare uno o più ACM associati al challenge detail
    createChallengeDetailAcm(payload: any | any[]): Observable<any> {
      return this.http.post(
        this.challengeDetailAcmUrl,
        payload
      );
    }
   */
  //CREAZIONE LIVELLI CON ACM ASSOCIATI
  challengeDetailAndAcmUrl = 'k7o/gui-shim/loy/challenge/challenge-detail-acm/saveCompositeChallengeDetailAcmList';
  updateChallengeDetailAndAcmUrl = 'k7o/gui-shim/loy/challenge/challenge-detail-acm/editCompositeChallengeDetailAcmList';

  createLevelWithAcm(payload: any) {
    return this.http.post(
      `${this.challengeDetailAndAcmUrl}`,
      payload
    );
  }
  //UPDATE LIVELLI CON ACM ASSOCIATI
  updateLevelWithAcm(currentLevelId: number, payload: any) {
    return this.http.put(
      `${this.updateChallengeDetailAndAcmUrl}/${currentLevelId}`,
      payload
    );
  }


  acmUrl = '/k7o/gui-shim/loy/challenge/'
  getChallengeAcm(challengeId: number): Observable<any> {
    return this.http.get(this.acmUrl + "challenge-acm/list?challengeId=" + challengeId);
  }



  deleteChallengeDetail(idDetail: number): Observable<any> {
    return this.http.delete(
      `${this.challengeDetailUrl}/${idDetail}`
    );
  }

  public acmTypeUrl = '/koncentro-loyalty/acm';
  getFromAcmType(acmTypeId): Observable<{ data: Array<AcmTypehasReason>, metadata: ListMetadata }> {

    const params: URLSearchParams = new URLSearchParams();
    if (acmTypeId)
      params.set('acm_type_id', acmTypeId);
    return this.http.getPaged(this.acmTypeUrl + '/acm_type/getReasons?' + params.toString());
  }

  public clusterUrl = '/koncentro-loyalty/cluster';
  getClusterHeadAllListWithParams_old(search?: Array<{ key: string, value: string }>): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }
    return this.http.get(this.clusterUrl + '/getClusterHeadAllList?' + params.toString());
  }

  getClusterHeadAllListWithParams(search?: Array<{ key: string, value: string }>): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    // aggiungi il limite fisso
    params.set('limit', '99999');

    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }

    return this.http.get(this.clusterUrl + '/getClusterHeadAllList?' + params.toString());
  }

  //----------------CRUD CHALLENGE---------------------------

  saveFullChallengeURL = 'k7o/gui-shim/loy/challenge/challenge/saveCompositeChallenge';
  editFullChallengeURL = 'k7o/gui-shim/loy/challenge/challenge/editCompositeChallenge';

  createFullChallenge(payload: any) {
    return this.http.post(`${this.saveFullChallengeURL}`, payload);
  }

  editFullChallenge(id: number, payload: any) {
    return this.http.put(`${this.editFullChallengeURL}/${id}`, payload);
  }



  challengeUrl = '/k7o/gui-shim/loy/challenge/challenge/gui/';
  getChallengeDataForEdit(idChallenge: number): Observable<ChallengeDetailTotalResponse> {
    return this.http.get(
      this.challengeUrl + idChallenge + "/info-details"
    );
  }

  saveChallengeUrl = '/k7o/gui-shim/loy/challenge/challenge';
  challengeApiUrl = "k7o/gui-shim/loy/challenge/challenge-api/";

  // creazione challenge
  createChallenge(payload: SaveChallengeDto): Observable<any> {
    return this.http.post(
      this.saveChallengeUrl,
      payload
    );
  }
  editChallenge(payload: SaveChallengeDto, idChallenge: number): Observable<any> {
    return this.http.put(
      this.saveChallengeUrl + '/' + idChallenge,
      payload
    );
  }
  //salvataggio degli acm nella sfida
  saveChallengeAcmUrl = "/k7o/gui-shim/loy/challenge/challenge-acm/saveOrEditChallengeAcm"
  saveChallengeAcm(challengeId: number, acmIds: number[]): Observable<any> {
    const payload = {
      challenge_id: challengeId,
      acm_ids: acmIds
    };

    return this.http.post(`${this.saveChallengeAcmUrl}`, payload);
  }

  saveChallengeOchannelUrl = '/k7o/gui-shim/loy/challenge/challenge-ochannel/saveOrEditChallengeOchannel';
  saveChallengeOchannels(payload: any): Observable<any> {
    return this.http.post(
      this.saveChallengeOchannelUrl,
      payload
    );

  }

  deleteChallenge(idChallenge: number): Observable<any> {
    return this.http.delete(
      `${this.saveChallengeUrl}/${idChallenge}`
    );
  }

  //----------------CRUD PREMI---------------------------

  giftUrl = "/k7o/gui-shim/loy/challenge/challenge-reward/saveOrEditListReward"
  //editare un Premio
  editChallengeGifts(payload: PremioDTO[], idChallenge: number): Observable<any> {
    return this.http.put(
      this.giftUrl + "/" + idChallenge,
      payload
    );
  }
  //salvare un Premio
  createChallengeGifts(payload: PremioDTO[]): Observable<any> {
    return this.http.post(
      this.giftUrl,
      payload
    );
  }

  getGiftsUrl = "/k7o/gui-shim/loy/challenge/challenge-reward/list?"
  //se presente deve restituirmi i dettagli del premio
  getGiftsDetailIfPresent(challengeId: number, levelId: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.set('challengeId', challengeId.toString())
    params.set('challengeDetailId', levelId.toString());

    return this.http.get(this.getGiftsUrl + params.toString());


  }
  //----------------CRUD GRAFCI---------------------------
  private graphicBaseUrl = '/k7o/gui-shim/loy/challenge/challenge-api/overview';

  // 1) Overview Participants
  getOverviewParticipants(payload: OverviewPartecipantsDTO): Observable<ParticipantOverviewResponse[]> {
    return this.http.post(
      `${this.graphicBaseUrl}/participants`,
      payload
    );
  }



  partecipantOverviewURL = "/k7o/gui-shim/loy/challenge/challenge-api/overview"
  getPartecipantOverview(
    offset: number | null = null,
    limit: number | null = null,
    search?: Array<{ key: string; value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<ChallengeResponse>; metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    const paramsString = params.toString().replace(/\+/g, '%2B');

    return this.http.getPaged(`${this.partecipantOverviewURL}/participants?${paramsString}`);
  }



  // 2) Overview Participants Export
  exportOverviewParticipants(payload: GraphicsDTO): Observable<Blob> {
    return this.http.post(
      `${this.graphicBaseUrl}/participants/export`,
      payload,
      { responseType: 'blob' as 'json' }
    );
  }

  // 3) Overview Complete
  getOverviewComplete(payload: GraphicsDTO): Observable<ParticipantsOverviewSummary> {
    return this.http.post(
      `${this.graphicBaseUrl}/complete`,
      payload
    );
  }
  getOverviewCompleteCartesian(payload: GraphicsDTOChartesian): Observable<ChallengePeriodOverviewChartesian> {
    return this.http.post(
      `${this.graphicBaseUrl}/completeByPeriod`,
      payload
    );
  }
  // 3) Overview Complete
  /*   getOverviewCompleteWithFrequency(payload: GraphicsDTO2): Observable<ParticipantsOverviewSummary> {
      return this.http.post(
        `${this.graphicBaseUrl}/complete`,
        payload
      );
    } */


  // 4) Overview Complete Export
  exportOverviewComplete(payload: GraphicsDTO): Observable<any> {
    return this.http.post(
      `${this.graphicBaseUrl}/complete/export`,
      payload,
      { responseType: 'blob' as 'json' }
    );
  }


  getChallenges(): Observable<{ data: Array<ChallengeResponse>; metadata: ListMetadata }> {

    return this.http.getPaged(`${this.baseUrl}/list`);
  }


  getChallengeDetailById(
    challengeDetailId: number
  ): Observable<ChallengeDetail> {
    return this.http.get(
      this.challengeDetailsUrl +
      "/challenge-detail/" +
      challengeDetailId.toString()
    );
  }

  getChallengeTemplateList(
    challengeTemplateId?: number,
    challengeTemplateCode?: string,
    challengeTypeId?: number
  ): Observable<ChallengeTemplate[]> {
    const params: URLSearchParams = new URLSearchParams();
    challengeTemplateId
      ? params.set("challengeTemplateId", challengeTemplateId.toString())
      : null;
    challengeTemplateCode
      ? params.set("challengeTemplateCode", challengeTemplateCode)
      : null;
    challengeTypeId
      ? params.set("challenge_type_id", challengeTypeId.toString())
      : null;

    return this.http.get(
      this.challengeDetailsUrl + "/challenge-template/list?" + params.toString()
    );
  }

  getActiveChallenges(
    customerId: string,
    offset: number | null = null,
    limit: number | null = null,
    search?: Array<{ key: string; value: string }>,
    globalSearch?: string,
    sort: string = "dateStart",
    sort_dir: number = -1
  ): Observable<{ data: Array<ChallengeResponse>; metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(
      offset,
      limit,
      search,
      globalSearch,
      sort,
      sort_dir
    );
    const paramsString = params.toString().replace(/\+/g, "%2B");

    return this.http.postPaged(
      `${this.challengeApiUrl}gui/activeChallenges?${paramsString}`,
      {
        customerId: customerId,
      }
    );
  }

  getReachedLevels(
    challengeId: number,
    customerId: string
  ): Observable<ReachedLevel[]> {
    return this.http.get(`${this.challengeUrl}${challengeId}/reached-levels?customerId=${customerId}`);
  }




  //Chiamate per Pubblicazione
  publishUrl = '/k7o/gui-shim/loy/challenge/challenge/publish';

  // PUBLISH
  publishChallenge(challengeId: number): Observable<any> {
    return this.http.post(
      `${this.publishUrl}?challengeId=${challengeId}`,
      {}
    );
  }
  unPublishUrl = '/k7o/gui-shim/loy/challenge/challenge/undoPublish';
  // UNDO PUBLISH
  undoPublishChallenge(challengeId: number): Observable<any> {
    return this.http.post(
      `${this.unPublishUrl}?challengeId=${challengeId}`,
      {}
    );
  }
  private frequencyParamUrl = '/koncentro-loyalty/params';

  getFrequencyParam(): Observable<FrequencyParam[]> {
    return this.http.get(
      `${this.frequencyParamUrl}?param_group=FrequencyLimitsDashboardChallenge`
    );
  }



}



// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge.service.ts